import { render, staticRenderFns } from "./CardsTotais.vue?vue&type=template&id=1dd18839&scoped=true"
import script from "./CardsTotais.vue?vue&type=script&lang=js"
export * from "./CardsTotais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd18839",
  null
  
)

export default component.exports